import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

export type PathType = 'patient' | 'representative' | '';

@InjectModule({ stateFactory: true }, module)
export default class PathModule extends InjectVuexModule {
    path: PathType = '';

    @Mutation
    setPath(path: PathType) {
        this.path = path;
    }
}
